import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  certificateAuthorityQueryKeys,
  endpointOidcProviderQueryKeys,
  hostQueryKeys,
  networkQueryKeys,
  Networks,
} from '#api';
import { makeNetworkQueryOptions } from '#api/networks.queries.ts';

export function useUpdateNetworkMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (networkId: string) => Networks.updateNetwork(networkId),
    onSuccess: async (data, networkId) => {
      const { queryKey } = makeNetworkQueryOptions(networkId);
      // A detail fetch started before the update would otherwise land after this write and restore the v1 network.
      await queryClient.cancelQueries({ queryKey });
      queryClient.setQueryData(queryKey, { data });
      // Updating adds v2 CAs and gives every host an IPv6 address, so host lists and details both go stale.
      void queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: hostQueryKeys.all() });
      void queryClient.invalidateQueries({ queryKey: certificateAuthorityQueryKeys.all() });
      // The api also rewrites every endpoint OIDC provider's auto-assign CIDRs to include the new IPv6 range.
      void queryClient.invalidateQueries({ queryKey: endpointOidcProviderQueryKeys.all() });
    },
  });
}
